import BaseMap from 'components/BaseMap/BaseMap';
import { memo } from 'react';
import { CURRENT_CONDITIONS_DEFAULT_ZOOM } from '../../config/currentConditions.config';
import CurrentConditionsMapLayers from './components/CurrentConditionsMapLayers/CurrentConditionsMapLayers';

// Memoized so poll-status renders in the parent (isFetching flips) don't re-render
// the BaseMap/MarkerClusterGroup subtree when the data itself is unchanged.
const CurrentConditionsMapContent = ({ conditions = [], center, scrollZoom = true }) => (
  <div className="current-conditions-map position-relative d-flex h-100 min-h-0 w-100 overflow-hidden rounded-2">
    <BaseMap
      mapCenter={center}
      preserveLocationZoom
      scrollZoom={scrollZoom}
      zoom={CURRENT_CONDITIONS_DEFAULT_ZOOM}
    >
      <CurrentConditionsMapLayers conditions={conditions} />
    </BaseMap>
  </div>
);

export default memo(CurrentConditionsMapContent);
